import React from 'react';
import styled from 'styled-components';
import { LoadingCommonProps, LoadingSpinner } from './';

export const LoadingDataGrid: React.FunctionComponent<Pick<LoadingCommonProps, 'loading'>> = ({ loading = false }) => {
  return loading ? (
    <div className="-loading -active" style={{ zIndex: 0 }}>
      <SpinnerWrapper className="-loading-inner">
        <LoadingSpinner />
      </SpinnerWrapper>
    </div>
  ) : null;
};

const SpinnerWrapper = styled.div`
  top: 35% !important;
`;

export default LoadingDataGrid;
